import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
import axios from 'axios';

function openDetails(e) {
  const t = e.currentTarget;
  const i = t.querySelector('.more');
  const d = t.querySelector('.detail');

  // console.dir(d);

  // change the + to a -
  i.classList.toggle('fa-plus-square');
  i.classList.toggle('fa-minus-square');

  if(t.classList.contains('open')) {
    d.removeAttribute('style');
    // console.log('close me');
  } else {
    d.setAttribute('style', 'height:' + d.scrollHeight + 'px; opacity:1;');
    // console.log('open me');
  }

  // toggle the open class for the next click event
  t.classList.toggle('open');
}
export class Calendar extends Component  {
  state = {
    events: []
  }

  componentDidMount() {
    const getMainNav = axios.get('./data/eventData.json');

    Promise.all([getMainNav]).then(res => {
      console.dir(res[0].data[this.props.month]);
      this.setState({
        events: res[0].data[this.props.month],
      });
    });
  }

  topOfContent() {
    let form = document.querySelector('#site');
    const y = form.offsetTop;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  // tempalates
  fullDetail() {

  }

  render() {
    const month = this.props.month;
    const { events } = this.state;

    return (
      <>
        <div id={ month } className="calList">
          <div className="monContainer">
            <h2>{ month }</h2>

            {events.map((e, key) => {
              if(e.details !== "") {

                let display = (e.sources.length >= 1) ? "true" : "false";
                // If the event has details
                return <div className={ 'calDate dets ' + e.class } key={ key } onClick={ openDetails }>
                    <div className="date">{ e.date }</div>
                    <div className="event">
                      { e.title }
                      <i className="fa fa-plus-square more"></i>
                    </div>

                    <div className="detail">
                      <p dangerouslySetInnerHTML={{ __html: e.details }} />

                        <p className={"sources strong " + display }>SOURCES:<br/>
                          {e.sources.map((s, key) => {
                            return (
                              <a href={ s.l } key={ key } target="_blank" rel="noopener noreferrer">{ s.t }</a>
                            );
                          })}
                        </p>
                    </div>
                  </div>
              } else {
                // If there are no details
                return <div className={ 'calDate ' + e.class } key={ key }>
                    <div className="date">{ e.date }</div>
                    <div className="event">
                      { e.title }
                    </div>
                  </div>
              }
            })}

          </div>

          <p className="toTop" onClick={ this.topOfContent }><i className="fa fa-arrow-circle-up"></i> Back to top</p>
        </div>
      </>
    );
  }
}

export default Calendar;